const getDefaultState = () => {
  return {
    isLoading: false
  }
}

const state = getDefaultState()

const mutations = {
  START_LOADING: (state) => { state.isLoading = true },
  FINISH_LOADING: (state) => { state.isLoading = false }
}

const actions = {
  startLoading: ({ commit }) => { commit('START_LOADING') },
  finishLoading: ({ commit }) => { commit('FINISH_LOADING') }
}

const getters = {
  isLoading: state => state.isLoading
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
